export enum UsagePlanMetricType {
  Customers = 'customers',
  Subscribers = 'subscribers',
  ActiveKnownCustomers = 'active_known_customers',
  UniqueVisitors = 'unique_visitors',
}
